export class PageOptions {
    argument: any = "";
    page: number = 0;
    sizePage: number = 50;
    fieldSort?: string = 'name'  || '';
    sortDirection: string = "asc";

}